
/**
 * 
 * @param {String} url 
 * @returns Promise
 */
export function leerGeoJSON(url) {
  return fetch(url)
  .then(response => response.ok
    ? response.json()
    : {features: []}
  )
}

export class CapaDinamica {
  __primeraCarga = true
  actualizador = 0
  _features = []
  constructor(id) {
    this.id = id
  }

  get features() {
    return this._features
  }
  set features(features) {
    this._features = features
    if (!this.__primeraCarga) {
      // No actualizar en la primer carga
      this.actualizar()
    } else {
      this.__primeraCarga = false
    }
  }

  actualizar() {
    this.actualizador++
  }
}